// extracted by mini-css-extract-plugin
export default {"button":"Pagination_button__IlvgQ","pagination":"Pagination_pagination__82qAT","active":"Pagination_active__THnKb"};